import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { VideoPlayerComponent } from 'src/app/components/video-player/video-player.component';
import { BasePage } from 'src/app/lib/base-page';
import { UserRepository } from 'src/app/repositories/user.repository';
import { AppointmentService } from 'src/app/services/appointment.service';

@Component({
  selector: 'app-beratung-watch-recording',
  templateUrl: './beratung-watch-recording.page.html',
  styleUrls: ['./beratung-watch-recording.page.scss'],
})
export class BeratungWatchRecordingPage extends BasePage implements OnInit {
  @ViewChild(VideoPlayerComponent) videoPlayer: VideoPlayerComponent;
  srcLink: string
  srcPoster: string

  constructor(private route: ActivatedRoute, private appointmentService: AppointmentService) {
    super()
  }

  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      const apiCall = UserRepository.getInstance().user().group_name === 'nurse'
        ? this.appointmentService.getNurseAppointmentById(params.id)
        : this.appointmentService.getUserAppointmentById(params.id);
      apiCall.subscribe(appointment => {
        this.srcLink = appointment.data.video_record[0].record_url
        this.srcPoster = appointment.data.video_record[0].thumbnail
      })
    })
  }
}
